import { configuration } from "../configuration";


export async function getToken(roomName: string, participantName: string,): Promise<string> {
    return fetch(`${configuration().TOKEN_GETTER_URL}/token/${roomName}/${participantName}`).then(res => res.text())
}